import { getFullUrl } from 'hubspot-url-utils';

const baseHubSpotUrl = getFullUrl('app');

export const getSnippetsUrl = (portalId: number) => {
  return `${baseHubSpotUrl}/snippets/${portalId}`;
};

export const getNewSnippetsUrl = (portalId: number) => {
  return `${baseHubSpotUrl}/snippets/${portalId}/new`;
};

export const getDocumentsUrl = (portalId: number) => {
  return `${baseHubSpotUrl}/documents/${portalId}`;
};

export const getKnowledgeUrl = (portalId: number, knowledgeBaseId?: number) => {
  const url = `${baseHubSpotUrl}/knowledge/${portalId}`;
  return knowledgeBaseId ? `${url}/${knowledgeBaseId}` : url;
};

export const getMeetingsUrl = (portalId: number) =>
  `${baseHubSpotUrl}/meetings/${portalId}`;

export const getVideosUrl = (portalId?: number) =>
  `${baseHubSpotUrl}/videos/${portalId}`;
